// Which stock item a Code typed in a Sales import can be sold from. Same
// rules as the Add Sale picker: not consigned (memo in) stock, and some
// carat still free; the Dummy code and legacy on-memo items always count.

import type { InventoryItem } from '../types';

const norm = (s: string | undefined) => (s ?? '').trim().toLowerCase();

export function availableCaratOf(item: InventoryItem): number {
  return Math.max(0, item.carat - (item.memoCommittedCarat ?? 0));
}

/** The stock item a typed Code can be sold from, or undefined. Same rules as the Add Sale picker. */
export function sellableByCode(inventory: InventoryItem[], code: string, dummyId?: string): InventoryItem | undefined {
  const c = norm(code);
  if (!c) return undefined;
  return inventory.find(i => {
    if (norm(i.code) !== c) return false;
    if (i.provenance === 'memo-in') return false;
    if (i.id === dummyId) return true;
    if (i.status === 'on-memo') return true;
    return i.status === 'in-stock' && availableCaratOf(i) > 1e-9;
  });
}
